// Расписание резервного копирования

import {AxiosResponse} from 'axios';
import base_ds, {CrudOperates} from '@/services/base_datasource_service';
import DataSource from 'devextreme/data/data_source';
import {BaseEntity, IResponseResult} from './base_types';

export const route_ns = 'admin/backup_schedule';

export class BackupSchedule extends BaseEntity {
  days_of_week: string = '';
  time: string = '';
  run_once: boolean = false;
  have_run: string | Date | null = null;
}

class entityClass extends BackupSchedule {}

class BackupScheduleService {
  public dataSource: DataSource;
  public crud: CrudOperates;

  public selected_row: BackupSchedule | null = null;
  public edit_popup_visible: boolean = false;
  public edit_mode: boolean = false;

  constructor() {
    this.dataSource = base_ds.getBaseDataSource(route_ns);
    this.crud = base_ds.getBaseCrud(route_ns);
  }

  public async get(): Promise<IResponseResult<BackupSchedule[]>> {
    const response: AxiosResponse['data'] = await this.crud.get();
    if (response && response.status === 'success' && Array.isArray(response.data)) {
      return {data: (response.data as BackupSchedule[])};
    } else if (response && response.message) {
      return {data: null, message: response.message};
    }
    return {data: null, message: ''};
  }

  public async getById(entityId: string): Promise<IResponseResult<BackupSchedule>> {
    const response: AxiosResponse['data'] = await this.crud.get_by_id(entityId);
    if (response && response.status === 'success' && response.totalCount === 1) {
      return {data: (response.data as BackupSchedule)};
    } else if (response && response.message) {
      return {data: null, message: response.message};
    }
    return {data: null, message: ''};
  }

  public async save(entity: entityClass): Promise<IResponseResult<BackupSchedule>> {
    const response: AxiosResponse['data'] = await this.crud.save(entity);

    if (response) {
      return {data: (response as BackupSchedule)};
    } else {
      return {data: null, message: ''};
    }

  }

  public async delete(entity: entityClass) {
    return this.crud.delete(entity.id);
  }

  public setEditPopupVisible(vis: boolean) {
    this.edit_popup_visible = vis;
  }

  public setEditMode(mode: boolean) {
    this.edit_mode = mode;
  }

  public setCurrentRow(data: entityClass | null) {
    this.selected_row = data;
  }
}

export default new BackupScheduleService();
